import Api from 'utils/ApiRequest'
import API_URL from 'constants/api'
import { showSpinner, hideSpinner } from 'action/spinner'

import {
  FETCH_USE_CONSUME_JUSTIFICATION_LIST_REQUEST,
  FETCH_USE_CONSUME_JUSTIFICATION_LIST_SUCCESS,
  FETCH_USE_CONSUME_JUSTIFICATION_LIST_ERROR,
  UPDATE_USE_CONSUME_JUSTIFICATION_REQUEST,
  UPDATE_USE_CONSUME_JUSTIFICATION_SUCCESS,
  UPDATE_USE_CONSUME_JUSTIFICATION_ERROR,
  GET_PAGES,
} from 'actionTypes'

const getPages = (metadata) => ({
  type: GET_PAGES,
  pages: metadata.pageCount,
  current: metadata.page,
  count: metadata.totalCount,
})

export const UseConsumeJustificationFetchList =
  (token, page = 1) =>
  (dispatch) => {
    dispatch(UseConsumeJustificationFetchListRequest())
    const param = {
      page,
    }

    return new Api(token, dispatch)
      .get(API_URL.LIST_USE_CONSUME_JUSTIFICATION, param)
      .then(dispatch(showSpinner()))
      .then((response) => {
        dispatch(getPages(response.data.pagination))
        dispatch(
          UseConsumeJustificationFetchListSuccess(response.data.listPresenter)
        )
        dispatch(hideSpinner())
      })
      .catch((error) => {
        dispatch(UseConsumeJustificationFetchListError(error))
        dispatch(hideSpinner())
      })
  }

export const UseConsumeJustificationFetchListRequest = () => ({
  type: FETCH_USE_CONSUME_JUSTIFICATION_LIST_REQUEST,
})

export const UseConsumeJustificationFetchListSuccess = (data) => ({
  type: FETCH_USE_CONSUME_JUSTIFICATION_LIST_SUCCESS,
  payload: data,
})

export const UseConsumeJustificationFetchListError = (error) => ({
  type: FETCH_USE_CONSUME_JUSTIFICATION_LIST_ERROR,
  payload: error,
})

export const UseConsumeJustificationUpdate = (token, values) => (dispatch) => {
  dispatch(UseConsumeJustificationUpdateRequest())

  const fields = {
    ...values,
  }

  return new Api(token, dispatch)
    .post(API_URL.SAVE_USE_CONSUME_JUSTIFICATION, fields)
    .then(dispatch(showSpinner()))
    .then((response) => {
      dispatch(UseConsumeJustificationUpdateSuccess(response.data))
      dispatch(UseConsumeJustificationFetchList(token))
      dispatch(hideSpinner())
    })
    .catch((error) => {
      dispatch(UseConsumeJustificationUpdateError(error))
      dispatch(hideSpinner())
    })
}

export const UseConsumeJustificationUpdateRequest = () => ({
  type: UPDATE_USE_CONSUME_JUSTIFICATION_REQUEST,
})

export const UseConsumeJustificationUpdateSuccess = (data) => ({
  type: UPDATE_USE_CONSUME_JUSTIFICATION_SUCCESS,
  payload: data,
})

export const UseConsumeJustificationUpdateError = (error) => ({
  type: UPDATE_USE_CONSUME_JUSTIFICATION_ERROR,
  payload: error,
})

export const UseConsumeJustificationRemove = (token, id) => (dispatch) =>
  new Api(token, dispatch)
    .post(API_URL.REMOVE_USE_CONSUME_JUSTIFICATION, id)
    .then(dispatch(showSpinner()))
    .then(() => {
      dispatch(UseConsumeJustificationFetchList(token))
      dispatch(hideSpinner())
    })
    .catch((error) => {
      dispatch(UseConsumeJustificationUpdateError(error))
      dispatch(hideSpinner())
    })
